/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

import {ForgotPassword} from './components/ForgotPassword'
import {ForgotPasswordCodeVerification} from './components/ForgotPasswordCodeVerification'
import {Login} from './components/Login'
import {Registration} from './components/Registration'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/progress-hd.png')})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo150.png')} className='h-45px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' render={() => <Registration roles="EmployerAdmin,Recruiter" />} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/forgot-password-code-verify/:email' component={ForgotPasswordCodeVerification} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            
            <Redirect to='/auth/login' />
          </Switch>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}